// extracted by mini-css-extract-plugin
module.exports = {"favourites-container":"Favourites_favourites-container__2BvI7","message":"Favourites_message__2wiqb","pagination":"Favourites_pagination__fd1u9"};